import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Device } from "../data/Device";
import { AxiosError } from "axios";

type UpdateDeviceInput = Omit<Device, 'lifeTime'>;

async function update(data: UpdateDeviceInput): Promise<void> {
    try {
       await ApiClient({ url: `/devices/${data.id}`, method: "PUT", data });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePutDeviceMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, UpdateDeviceInput>({
        mutationKey: ["put-device"],
        mutationFn: update,
        onSuccess: onSuccess,
        onError: onError
    });
}
